import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { IngredientsServices } from '../../../ingredients/services';

/**
 * Generated class for the DishTutorialSlidePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ingredient-tutorial-slide',
  templateUrl: 'ingredient-tutorial-slide.html',
})
export class IngredientTutorialSlidePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public ingredientsServices: IngredientsServices) {
  }

  ionViewDidLoad() {
  }

  ionViewDidLeave() {
    this.closeLeave();
  }

  close() {
    this.globals.restaurant.tutorial_ingredient = true;
    this.ingredientsServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_ingredient': this.globals.restaurant.tutorial_ingredient,
    }).then(() => {
      this.navCtrl.pop();
    });

  }

  closeLeave(){
    this.globals.restaurant.tutorial_ingredient = true;
    this.ingredientsServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_ingredient': this.globals.restaurant.tutorial_ingredient,
    }).then(() => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/help/tutorial-slider/ingredient-tutorial-slide/ingredient-tutorial-slide.ts